/**
 * @created on 2017/9/21
 * @author laixinyu <laixinyualex@gmail.com>
 **/

import appointment from './appointment'
import capital from './capital'
import channel from './channel'
import equipment from './equipment'

export default [...appointment, ...capital, ...channel, ...equipment]



// WEBPACK FOOTER //
// ./src/router/page/consult/index.js